@if (isManagingAudit) {
  <app-report-audit-manage></app-report-audit-manage>
}
@if (isEditingAudit) {
  <div class="table-box">
    <app-audit-edit [editedAuditId]="editedAuditId"></app-audit-edit>
  </div>
}